module.exports = __webpack_public_path__ + "footer-0f55b30f3dbc965de5d929c86b160aec.svg";